import React from 'react';
import styled from 'styled-components';
import { css } from '/imports/ui/css';

const CheckboxStyled = styled.label`
  position: relative;
  input {
    border: 1px solid ${css.grey4};
    border-radius: 0.25rem;
    padding: 0.5rem 0.75rem;
    font-size: 1rem;
    font-family: ${css.fontFamily};
    appearance: none;
    width: 1.5rem;
    height: 1.5rem;
    // The tick centres on this box, so the box has to stay square whatever it is dropped into: flex: none
    // stops a flex row squashing it against a long label, and aspect-ratio keeps it square if a page
    // overrides only one dimension. Both hold for a page that resizes it deliberately, as the bulk editor does.
    flex: none;
    aspect-ratio: 1;
    padding: 0;
    position: relative;
    top: -0.15rem;
    margin-right: 0.5rem;
    cursor: pointer;
    &:checked {
      background-color: ${css.primaryColor};
      border-color: ${css.primaryColor};
      // The tick is the input's own background, not a positioned element beside it: it therefore centres on
      // the box itself and no container's layout can shift it off. Sized in % so it follows a resized box.
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 -960 960 960' fill='%23ffffff'%3E%3Cpath d='M382-240 154-468l57-57 171 171 367-367 57 57-424 424Z'/%3E%3C/svg%3E");
      background-repeat: no-repeat;
      background-position: center;
      background-size: 70%;
      &:disabled {
        background-color: ${css.grey4};
        border-color: ${css.grey4};
      }
    }
    &:disabled {
      background-color: ${css.grey8};
      border-color: ${css.grey4};
    }
    &::placeholder {
      text-transform: capitalize;
    }
  }
`;

export interface CheckboxProps {
  id?: string;
  className?: string;
  checked?: boolean;
  onChange?(checked: boolean, e: React.ChangeEvent<HTMLInputElement>): void;
  children?: React.ReactNode;
  disabled?: boolean;
}

/** Styled checkbox input that reports its checked state via onChange. */
export const Checkbox = (props: CheckboxProps) => {
  return (
    <CheckboxStyled>
      <input
        id={props.id}
        className={`checkbox-label${props.className ? ` ${props.className}` : ''}`}
        type='checkbox'
        checked={props.checked}
        disabled={props.disabled}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => props.onChange?.(e.target.checked, e)}
      />
      {props.children || null}
    </CheckboxStyled>
  );
};